module.exports.on = require('./on')
module.exports.off = require('./off')
module.exports.emit = require('./emit')
